import _extends from "babel-runtime/helpers/extends";
export default function createStore(initialState) {
    var state = initialState;
    var listeners = [];
    function setState(partial) {
        state = _extends({}, state, partial);
        for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
        }
    }
    function getState() {
        return state;
    }
    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }
    return {
        setState: setState,
        getState: getState,
        subscribe: subscribe
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/createStore.js
// module id = 672
// module chunks = 0